import { render } from "./AssessmentView.vue?vue&type=template&id=56b2fd83"
import script from "./AssessmentView.vue?vue&type=script&lang=js"
export * from "./AssessmentView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__